import Modal from "react-bootstrap/Modal";
import { useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../redux/TransactionAction";
import { getCookie } from "../../slidebar/components/DarkMode";

export const GoogleAuthModal = ({ setShow, show }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const transactionState = useSelector(
    ({ transaction }) => transaction,
    shallowEqual
  );
  const [mode, setMode] = useState(getCookie("selectedTheme"));

  const handleClose = () => setShow(false);

  useEffect(() => {
    const handle = () => {
      setMode((prev) => (prev === "dark" ? "light" : "dark"));
    };

    window.addEventListener("setTheme", handle);

    return () => {
      window.removeEventListener("setTheme", handle);
    };
  }, []);

  useEffect(() => {
    if (show) {
      dispatch(
        actions.generateGoogleAuthQR({ action: "googleauthoqrgenerate" })
      );

      return () => dispatch(actions.clearGoogleAuthQR());
    }
  }, [show]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        data-bs-theme={mode}
        className="zIndex-9999"
        backdropClassName="zIndex-9999"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {intl.formatMessage({
              id: "googleAuthentication",
            })}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {transactionState.googleAuthQR ? (
            <div className="d-flex flex-column align-items-center justify-content-center gap-4">
              <img src={transactionState.googleAuthQR.qrbase64} />
              <div>{transactionState.googleAuthQR.entrykey}</div>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
          >
            {intl.formatMessage({ id: "close" })}
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
